import { Box, Typography } from "@mui/material";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import PropTypes from "prop-types";

/**
 * Branded "Meet" pill used inside table rows for the Google Meet link column.
 * Renders a green pill (Google Meet color cue) with a video camera icon and
 * "Meet" label that opens the link in a new tab. Falls back to a muted dash
 * when no link is available.
 */
const MeetLinkCell = ({ href, label = "Meet", emptyText = "—" }) => {
  if (!href) {
    return (
      <Typography
        sx={{
          fontSize: 13,
          color: "#98A2B3",
          textAlign: "center",
          width: "100%",
        }}
      >
        {emptyText}
      </Typography>
    );
  }

  return (
    <Box
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Open Google Meet link${label ? `: ${label}` : ""}`}
      onClick={(event) => event.stopPropagation()}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.6,
        height: 26,
        px: 1.05,
        borderRadius: "999px",
        bgcolor: "#E6F4EA",
        color: "#1A7F37",
        border: "1px solid #C6E5CD",
        textDecoration: "none",
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1,
        cursor: "pointer",
        transition: "background-color 120ms ease, border-color 120ms ease, transform 120ms ease",
        "&:hover": {
          bgcolor: "#D6EBDC",
          borderColor: "#1A7F37",
        },
        "&:focus-visible": {
          outline: "2px solid #1A7F37",
          outlineOffset: 2,
        },
        "&:active": {
          transform: "translateY(1px)",
        },
      }}
    >
      <VideocamOutlinedIcon sx={{ fontSize: 14 }} />
      <Box component="span" sx={{ lineHeight: 1 }}>
        {label}
      </Box>
    </Box>
  );
};

MeetLinkCell.propTypes = {
  href: PropTypes.string,
  label: PropTypes.string,
  emptyText: PropTypes.string,
};

export default MeetLinkCell;